import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {
  WORKFORCE_DASHBOARD_PAIRED_SECTION_CONTENT_MIN_HEIGHT,
  WORKFORCE_DASHBOARD_SCROLLABLE_SECTION_MAX_HEIGHT,
} from './workforceDashboardLayoutConstants';
import {WorkforceDashboardSectionCard} from './WorkforceDashboardSectionCard';
import {EmptyStateCard} from '../../../../../components/EmptyStateCard/EmptyStateCard';
import {WorkforceDashboardDimensionImbalance} from '../../types/workforceDashboardTypes';

export interface Props {
  data: WorkforceDashboardDimensionImbalance[] | null;
  onProfileClick: (resourceId: string) => void;
  fillHeight?: boolean;
}

export const WorkforceDashboardDimensionImbalances = ({data, onProfileClick, fillHeight}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceDashboardPage.sections.scoreDimensionImbalances'});

  if (!data || data.length === 0) {
    return (
      <WorkforceDashboardSectionCard title={t('title')} fillHeight={fillHeight}>
        <EmptyStateCard />
      </WorkforceDashboardSectionCard>
    );
  }

  return (
    <WorkforceDashboardSectionCard
      title={t('title')}
      description={t('description') as string}
      fillHeight={fillHeight}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          minWidth: 0,
          minHeight: WORKFORCE_DASHBOARD_PAIRED_SECTION_CONTENT_MIN_HEIGHT,
          flex: fillHeight ? 1 : undefined,
          maxHeight: WORKFORCE_DASHBOARD_SCROLLABLE_SECTION_MAX_HEIGHT,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {data.map((item) => (
          <Box
            key={item.resourceId}
            onClick={() => onProfileClick(item.resourceId)}
            sx={{
              cursor: 'pointer',
              p: 1.25,
              borderRadius: '8px',
              border: '1px solid',
              borderColor: 'divider',
              '&:hover': {bgcolor: 'action.hover'},
            }}
          >
            <Typography variant='h6'>
              {item.publicId}
            </Typography>
            <Typography variant='caption' sx={{color: 'text.secondary'}}>
              {t('itemSummary', {dimension: item.weakestDimension, score: item.weakestScore, delta: item.delta})}
            </Typography>
          </Box>
        ))}
      </Box>
    </WorkforceDashboardSectionCard>
  );
};
